<template>
  <div>
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.userName" placeholder="输入用户名"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.inviter" placeholder="输入邀请人"></el-input>
      </el-form-item>
      <el-form-item label="矿机Id">
        <el-select size="small" v-model="formInline.minerId" placeholder="请选择矿机Id">
          <el-option v-for="item in typeToken" :label="item.minerId == 0 ? '默认' : item.name" :value="item.minerId"
            :key="item.minerId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="矿机来源">
        <el-select size="small" v-model="formInline.type" placeholder="请选择矿机来源">
          <el-option v-for="item in typeMiner" :label="item.name" :value="item.value" :key="item.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <!-- <el-form-item>
        <el-button size="small" type="success"  @click="handleEdit">转移矿机</el-button>
      </el-form-item> -->
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%;">
      <el-table-column align="center" sortable prop="userName" label="用户名" min-width="100">
      </el-table-column>
      <el-table-column align="center" prop="minerName" label="矿机名" min-width="100">
      </el-table-column>
      <!-- <el-table-column align="center" sortable label="类型" min-width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.minerType == 'normal'">普通</div>
            <div v-if="scope.row.minerType == 'primary'">股东</div>
            <div v-if="scope.row.minerType == 'partner'">合伙人</div>
          </template>
        </el-table-column> -->
      <el-table-column align="center" sortable prop="value" label="矿机价值" min-width="100">
      </el-table-column>
      <el-table-column align="center" prop="num" label="数量" min-width="50">
      </el-table-column>
      <el-table-column align="center" label="txId" min-width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.txId != ''"><el-link icon="el-icon-link" type="primary" :underline="false" :title="scope.row.txId" :href="scope.row.url" target="_blank">{{ scope.row.txId.slice(0,6)+'……'+scope.row.txId.substr(scope.row.txId.length-6,6) }}</el-link></div>
          <div v-else>无</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="inviter" label="邀请人" min-width="100">
      </el-table-column>
      <el-table-column align="center" prop="setupTime" label="购买时间" min-width="100">
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 转移矿机 -->
    <el-dialog title="转移矿机" :visible.sync="movemine" width="30%" v-if="typeToken1 && typeToken1.length > 0"
      @click="movemine = false">
      <el-form :model="editForm" label-width="120px" :rules="Rules" ref="editForm">
        <el-form-item label="用户名" prop="userName">
          <el-input size="small" v-model="editForm.userName" auto-complete="off" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="矿机Id"  prop="minerId">
          <el-select size="small" v-model="editForm.minerId" placeholder="请选择矿机Id">
            <el-option v-for="item in typeToken1" :label="item.name" :value="item.minerId"
              :key="item.minerId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数量" prop="num">
          <el-input size="small" type="number" v-model="editForm.num" auto-complete="off" onkeyup="this.editForm.num=this.editForm.num.replace(/\D|^0/g)" placeholder="请输入数量"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="movemine = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitUser('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import { ordersList, ordersIdList , MoveMiner } from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      movemine:false,
      loading: false, //是显示加载
      formInline: {
        from: 1,
        limit: 10,
        minerId: 0,
        userName: "",
        inviter: "",
        type: ""
      },
      editForm:{
        userName:'',
        minerId:null,
        num:''
      },
      listData: [], //用户数据
      Rules: {
        userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        minerId: [{ required: true, message: '请选择矿机Id' }],
        num: [{ required: true, message: '请输入数量', trigger: 'blur' }],
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      typeToken: [{ minerId: 0, name: '' }],
      typeToken1:[],
      typeMiner: [{ value: '', name: '默认' }, { value: 'move', name: '转移矿机' }]
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取转入列表
    getdata(parameter) {
      this.loading = true
      ordersList(parameter)
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.listData = res.data.list
            // 分页赋值
            this.pageparm.total = res.data.total
            this.getdataId()
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('列表加载失败，请稍后再试！')
        })
    },
    //获取系统矿机配置
    getdataId() {
      this.loading = true
      this.typeToken = [{ minerId: 0, name: '' }]
      ordersIdList()
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.typeToken = this.typeToken.concat(res.data.list)
            this.typeToken1 = res.data.list
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('获取系统矿机配置失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.pageparm.pageSize = parm.pageSize
      this.formInline.from = (parm.currentPage - 1) * (this.pageparm.pageSize) + 1
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.pageparm.currentPage = 1
      this.formInline.from = 1
      this.getdata(this.formInline)
    },
    handleEdit() {
      this.editForm = {
        userName:'',
        minerId:null,
        num:''
      },
      this.movemine = true
    },
    submitUser(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          this.loading = true
          MoveMiner(this.editForm)
            .then(res => {
              this.loading = false
              this.movemine = false
              if (res.code == 0) {
                console.log(res)
                this.$message({
                  type: 'success',
                  message: '转移成功！'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            }).catch(err => {
              this.movemine = false
              this.loading = false
              this.$message.error('转移失败，请稍后再试！')
            })
        }
      })
    },
  }
}
</script>
  
<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>
  
   
   


// WEBPACK FOOTER //
// src/views/miner/Minerorder.vue